import React, {Component, Fragment} from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import {getValueFromDDL, removeNullFields} from "../../../common/mapper";
import SimpleInput from "../../../../modules/SimpleInput";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {initialData, tableColumns} from "./config";
import BeforeSubmissionFilter from "./beforeSubmissionFilter";
import Api from "../../../../Services/Api";
import {fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";

class BeforeSubmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filterModalVisible: false,
            tableColumns: [...tableColumns.mainPage],
            search: {...initialData.search},
            filterData: {...initialData.filter},
            selectedCabang: null,
            dataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        }
    }

    componentDidMount = async () => {
        if (!R.isNil(this.props.selectedCabang)) {
            this.handleTriggerLoading();
            await this.fetchData({
                ...removeNullFields(this.parseFilterData(this.state.search)),
                kodeCabang: this.props.selectedCabang?.value,
                limit: this.state.pagination.limit,
                page: 1
            });
            this.handleTriggerLoading();
        }
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.props.selectedCabang !== prevProps.selectedCabang) {
            this.handleTriggerLoading();
            this.setState((prevState) => ({
                ...prevState,
                search: {...initialData.search, kodeCabang: this.props.selectedCabang},
                filterData: {...initialData.filter, kodeCabang: this.props.selectedCabang}
            }))

            await this.fetchData({
                ...removeNullFields(this.parseFilterData(this.state.search)),
                kodeCabang: this.props.selectedCabang?.value,
                limit: 5,
                page: 1
            });
            this.handleTriggerLoading();
        }
    }

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            selectedCabang: this.state.search.kodeCabang,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearSearch = async (clearSearchFromFilter) => {
        console.log("here", clearSearchFromFilter)
        await this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                ...initialData.search
            },
        }));
        this.handleTriggerLoading();
        if (!clearSearchFromFilter) {
            await this.fetchData();
        }
        this.handleTriggerLoading();
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        await this.handleClearFilter();
        let requestBody = {
            ...removeNullFields(this.parseFilterData(this.state.search)),
            limit: this.state.pagination.limit,
            page: 1
        }
        
        await this.fetchData(requestBody);
        this.handleTriggerLoading();
    }

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {
                ...prevState.filterData,
                ...initialData.filter,
            },
        }));
    }

    handleOnSubmitFilter =  () => {
        this.handleTriggerLoading();

        this.setState(
          {
            pagination: {
              page: 1,
              limit: 5,
              totalData: 0,
            },
          },
          async () => {
            const filterData = {
              ...this.state.filterData,
              kodeVariant: this.filterAllOption(
                this.state.filterData.kodeVariant
              ),
              kodeWarna: this.filterAllOption(this.state.filterData.kodeWarna),
            };

            const requestBody = {
              ...removeNullFields(this.parseFilterData(filterData)),
              limit: this.state.pagination.limit,
              page: 1,
            };

            await this.fetchData(requestBody);
            this.handleClearSearch(true);
            this.handleModalFilterVisibility();
            this.handleTriggerLoading();
          }
        );
    }

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest};
        } else {
            paramFilters = {...searchRequest};
        }

        const reqBody = {
            ...paramFilters,
            kodeCabang: this.props.selectedCabang?.value,
            page: page,
            limit: limit
        }

        await this.fetchData(reqBody);
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));

        const filterRequest = removeNullFields(this.parseFilterData(this.state.filterData))
        const searchRequest = removeNullFields(this.parseFilterData(this.state.search))

        let paramFilters;
        if (!R.isEmpty(filterRequest)) {
            paramFilters = {...filterRequest, kodeCabang: this.props.selectedCabang?.value,};
        } else {
            paramFilters = {...searchRequest, kodeCabang: this.props.selectedCabang?.value};
        }

        const reqBody = {
            ...paramFilters,
            page: 1,
            limit: limit
        }

        await this.fetchData(reqBody);
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    parseFilterData(data) {
        return {
            ...data,
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            kodeVariant: data["kodeVariant"]?.map(({value}) => value),
            kodeWarna: data["kodeWarna"]?.map(({value}) => value),
        };
    }

    filterAllOption = (array) => {
        if (Array.isArray(array) && !R.isEmpty(array)) {
            return array.some(({value}) => R.equals(value, "ALL"))
                ? array.filter(({value}) => R.equals(value, "ALL"))
                : array;
        }
        return array;
    };

    fetchData = async (body) => {
        let req = body && Object.keys(body).length > 0 ?
            body :
            {
                kodeCabang: this.props.selectedCabang?.value,
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            };
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findAllBeforeSubmissionSamsat,
            menuName: "Proses Samsat - Belum Pengajuan",
            setError: this.props.setError,
            args: req,
        });

        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: !R.isNil(response.data.data) ? response.data.data : [],
                pagination: {
                    ...prevValue.pagination,
                    count: response.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    }

    render() {
        return (
            <>
                <FlexView vAlignContent="center" hAlignContent="right" style={{marginBottom: "20px"}}>
                    <SimpleInput
                        type="text"
                        name="namaSTNK"
                        placeholder="Nama STNK"
                        containerclassname="margin-bottom-none"
                        value={this.state.search.namaSTNK}
                        onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                    />
                    <SimpleButton
                        text="Cari"
                        onClick={this.handleSubmitSearch}
                        className="margin-top-5px"
                    />
                    <SimpleButton
                        text="Reset"
                        onClick={() => this.handleClearSearch(false)}
                        className="margin-top-5px"
                    />
                    <SimpleButton
                        className={"btn background-red margin-top-5px"}
                        styles={{width: "unset"}}
                        onClick={this.handleModalFilterVisibility}
                        icon={<i className="fa fa-qrcode"></i>}
                    />
                </FlexView>

                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.count}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(
                        (tableState) => this.handleChangePage(tableState),
                        (tableState) => this.handleChangeRowsPerPage(tableState),
                    )}
                />

                {this.state.filterModalVisible && (
                    <BeforeSubmissionFilter
                        filterData={this.state.filterData}
                        selectedCabang={this.props.selectedCabang}
                        visible={this.state.filterModalVisible}
                        onValueChange={this.handleFilterValueChange}
                        onSubmit={this.handleOnSubmitFilter}
                        onClearForm={this.handleClearFilter}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default BeforeSubmission;